import { Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router'; 
import { filter } from 'rxjs';
import { CommonModule } from '@angular/common';
import { UserContextService } from '../../../core/context/user.context';
import { UserRole } from '../../../core/enums/user-roles.enum';
import { AuthService } from '../../../services/auth.service';
import { HasPermissionDirective } from '../../../shared/directives/appHasPermission.directive';

interface MenuOption {
  key: string;
  route: string;
}

@Component({
  selector: 'app-sidebar',
  imports: [CommonModule,
    HasPermissionDirective
    ],
  standalone: true,
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.css',
})
export class SidebarComponent {
  currentUrl: string = '';
  sidebarWidth: number = 60;
  sidebarComprimido: boolean = true;
  isGuest: boolean = false;
  readonly UserRole = UserRole;
  
  private readonly menuOptions: MenuOption[] = [
    { key: 'HomeProcesosSeleccion', route: '/home' },
    { key: 'PotencialesProyectos', route: '/potenciales-proyectos/listar' },
    { key: 'Empresas', route: '/empresas/listar' },
    { key: 'Proyectos', route: '/proyectos/listar' },
    { key: 'Proveedores', route: '/proveedores/listar' },
    { key: 'GestionFinanciera', route: '/gestion-financiera/listar' },
    { key: 'Usuarios', route: '/usuarios/listar' },
  ];
  
  activeStates: Record<string, boolean> = {};
  hoverStates: Record<string, boolean> = {};
   
  private lastSelectedKey: string = 'home';

  constructor(
    private readonly router: Router,
    private readonly _userContext: UserContextService,
    private readonly authService: AuthService,
  ) {
    this.initializeStates();
  }

  async ngOnInit() {
    const user = this._userContext.currentUser?.trabajadorData || null;
    this.isGuest = false; //user?.user?.usGuest ?? false;
    this.definirSeleccionActualSidebar();
  }

  ngAfterViewInit() {
    this.router.events
      .pipe(filter((event: any) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.currentUrl = event.url;
        console.log('URL actual:', this.currentUrl);
        this.definirSeleccionActualSidebar();
      });
  }

  // Inicializar estados dinámicamente
  private initializeStates(): void {
    this.menuOptions.forEach(option => {
      this.activeStates[option.key] = option.key === 'home'; // Home activo por defecto
      this.hoverStates[option.key] = false;
    });
  }

  expandSidebar() {
    this.sidebarWidth = 285;
    this.sidebarComprimido = false;
  }

  collapseSidebar() {
    this.sidebarWidth = 60;
    setTimeout(() => {
      this.sidebarComprimido = true;
    }, 300);
  }

  definirSeleccionActualSidebar() {
    if (this.isGuest) return;
    
    const currentRoute = this.router.url;
    // console.log('Ruta actual:', currentRoute);

    // Buscar si la última opción seleccionada manualmente coincide con la ruta actual
    const lastOption = this.menuOptions.find(option => option.key === this.lastSelectedKey);
    if (lastOption && lastOption.route === currentRoute) {
      // Si la última opción seleccionada coincide con la ruta actual, mantenerla
      this.activateOption(this.lastSelectedKey, false);
      return;
    }

    // Si no, buscar la primera opción que coincida con la ruta actual
    const matchedOption = this.menuOptions.find(option => option.route === currentRoute);

    if (matchedOption) {
      this.activateOption(matchedOption.key, false);
      this.lastSelectedKey = matchedOption.key;
    } else {
      console.warn('Ruta no reconocida:', currentRoute);
    }
  }

  selectOptionSidebar(optionKey: string) {
    if (this.isGuest) return;

    console.log('Opción seleccionada en el sidebar:', optionKey);

    const selectedOption = this.menuOptions.find(option => option.key === optionKey);

    if (!selectedOption) {
      console.warn('Opción no reconocida:', optionKey);
      return;
    }

    // Guardar la última opción seleccionada manualmente
    this.lastSelectedKey = optionKey;

    // Activar la opción y navegar
    this.activateOption(optionKey, true);
  }

  // Método auxiliar para activar una opción
  private activateOption(optionKey: string, navigate: boolean = true): void {
    const selectedOption = this.menuOptions.find(option => option.key === optionKey);
    
    if (!selectedOption) return;

    // Desactivar todas las opciones
    Object.keys(this.activeStates).forEach(key => {
      this.activeStates[key] = false;
    });

    // Activar la opción seleccionada
    this.activeStates[selectedOption.key] = true;

    // Navegar a la ruta si es necesario
    if (navigate) {
      this.router.navigate([selectedOption.route]);
    }
  }

  // Métodos auxiliares para usar en el template
  isActive(key: string): boolean {
    return this.activeStates[key] || false;
  }

  isHover(key: string): boolean {
    return this.hoverStates[key] || false;
  }

  setHover(key: string, state: boolean): void {
    this.hoverStates[key] = state;
  }  
}
